import { useMap } from '@vis.gl/react-google-maps';
import React, { useEffect, useState } from 'react';
import { getLatLng } from './utils';

const MapBoundary = ({ place, boundaryInfo, locations }) => {
    const map = useMap();
    const [isBoundarySet, setIsBoundarySet] = useState(false);


    const extendBoundsForLocations = (bounds, locations) => {
        if (locations?.length) {
            locations.forEach((location) => {
                const locationPoint = getLatLng(location)
                if (locationPoint) {
                    bounds.extend(locationPoint);
                }
            });

            bounds.extend(place.geometry?.location);
        }
    }


    useEffect(() => {
        if (!map || !place || !boundaryInfo) return;

        const addressType = boundaryInfo?.addressType?.toUpperCase() ?? null;
        const boundaryPlaceId = boundaryInfo?.addressId ?? null;

        if (!addressType || !boundaryPlaceId) return;

        const featureLayer = map.getFeatureLayer(addressType);

        const featureStyleOptions = {
            strokeColor: "#810FCB",
            strokeOpacity: 1.0,
            strokeWeight: 3.0,
            fillColor: "#810FCB",
            fillOpacity: 0.5,
        };

        // highlight the boundary
        featureLayer.style = (options) => {

            if (options.feature.placeId === boundaryPlaceId) {
                if (addressType.toLowerCase() === "locality" && boundaryInfo?.geometry) {
                    const bounds = new window.google.maps.LatLngBounds();
                    bounds.extend(boundaryInfo.geometry.bounds.northeast);
                    bounds.extend(boundaryInfo.geometry.bounds.southwest);
                    extendBoundsForLocations(bounds, locations);
                    map.fitBounds(bounds, 80);
                }
                return featureStyleOptions;
            }
        };

        // rerender the map
        setIsBoundarySet(true);

    }, [map, place, boundaryInfo]);

    return null;
};

export default React.memo(MapBoundary);
